import { motion } from 'framer-motion';

interface SnapFeedSwipeHintProps {
  show: boolean;
}

export default function SnapFeedSwipeHint({ show }: SnapFeedSwipeHintProps) {
  if (!show) return null;
  
  return (
    <motion.div 
      className="absolute inset-x-0 bottom-4 flex justify-center pointer-events-none"
      initial={{ opacity: 1 }}
      animate={{ opacity: [1, 0.8, 1] }}
      transition={{ repeat: Infinity, duration: 2 }}
    >
      <div className="bg-black/50 text-white px-4 py-2 rounded-full text-sm backdrop-blur-sm">
        Swipe up for next, down for previous
      </div>
    </motion.div>
  );
}